import PropTypes from 'prop-types';
import React from 'react';

import TranslationUtils from 'Utils/TranslationUtils';

import c from '../../../Components/AuthLayout/authContent.module.less';
import { trackEvent } from '../../LeadVettingPage/utils';

const BlockPageForPublicDomains = ({ history }) => {
  const goBack = (e) => {
    e.preventDefault();
    trackEvent('public_email_back', '');
    history.goBack(e);
  };

  return (
    <>
      <h1 test-id="page-title" className={c.title}>
        {TranslationUtils.getText('BLOCK_PAGE_FOR_PUBLIC_DOMAINS_TITLE_INTRO')}
      </h1>
      <p className={c.text}>
        {`${TranslationUtils.getText('BLOCK_PAGE_FOR_PUBLIC_DOMAINS_TITLE_PREFIX')} `}
        <a href="#" onClick={goBack}>
          {TranslationUtils.getText('BLOCK_PAGE_FOR_PUBLIC_DOMAINS_TITLE_LINK_TEXT')}
        </a>
        {` ${TranslationUtils.getText('BLOCK_PAGE_FOR_PUBLIC_DOMAINS_TITLE_SUFFIX')}`}
      </p>
      <p className={c.text}>
        {TranslationUtils.getText('BLOCK_PAGE_SUBTITLE')}{' '}
        <a href="mailto:support@pipl.com">{TranslationUtils.getText('BLOCK_PAGE_LINK')}</a>
      </p>
    </>
  );
};

BlockPageForPublicDomains.propTypes = {
  history: PropTypes.object,
};

export default BlockPageForPublicDomains;
